export default [{
    type: 'AMEX',
    pattern: /^3[47]/,
    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
    length: [15],
    cvcLength: [4],
    luhn: true,
    css: 'fa fa-cc-amex',
}, {
    type: 'dankort',
    pattern: /^5019/,
    format: /(\d{1,4})/g,
    length: [16],
    cvcLength: [3],
    luhn: true
}, {
    type: 'DINERS',
    pattern: /^(36|38|30[0-5])/,
    format: /(\d{1,4})/g,
    length: [14],
    cvcLength: [3],
    luhn: true,
    css: 'fa fa-cc-diners-club',
}, {
    type: 'discover',
    pattern: /^(6011|65|64[4-9]|622)/,
    format: /(\d{1,4})/g,
    length: [16],
    cvcLength: [3],
    luhn: true,
    css: 'fa fa-cc-discover',
}, {
    type: 'JCB',
    pattern: /^35/,
    format: /(\d{1,4})/g,
    length: [16],
    cvcLength: [3],
    luhn: true,
    css: 'fa fa-cc-jcb',
}, {
    type: 'LASER',
    pattern: /^(6706|6771|6709)/,
    format: /(\d{1,4})/g,
    length: [16, 17, 18, 19],
    cvcLength: [3],
    luhn: true
}, {
    type: 'MAESTRO',
    pattern: /^(5018|5020|5038|6304|6703|6759|676[1-3])/,
    format: /(\d{1,4})/g,
    length: [12, 13, 14, 15, 16, 17, 18, 19],
    cvcLength: [3],
    luhn: true
}, {
    type: 'MASTERCARD',
    pattern: /^5[1-5]/,
    format: /(\d{1,4})/g,
    length: [16],
    cvcLength: [3],
    luhn: true,
    css: 'fa fa-cc-mastercard',
}, {
    type: 'unionpay',
    pattern: /^62/,
    format: /(\d{1,4})/g,
    length: [16, 17, 18, 19],
    cvcLength: [3],
    luhn: false
}, {
    type: 'visaelectron',
    pattern: /^4(026|17500|405|508|844|91[37])/,
    format: /(\d{1,4})/g,
    length: [16],
    cvcLength: [3],
    luhn: true,
    css: 'fa fa-cc-visa',
}, {
    type: 'VISA',
    pattern: /^4/,
    format: /(\d{1,4})/g,
    length: [13, 14, 15, 16],
    cvcLength: [3],
    luhn: true,
    css: 'fa fa-cc-visa',
}];
